// @ts-nocheck
import { TaxExemptionCertificateModel } from "@store/Framework/Types/ApiModels";
import { GetSingleTaxExemptionCertificateApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";
import loadTaxExemptionCertificatesByCertificateId from "@store/Framework/Store/Greif/Data/TaxExemptionCertificates/Handlers/LoadTaxExemptionCertificatesByCertificateId";
import { getTECertificateState } from "@store/Framework/Store/Greif/Data/TaxExemptionCertificates/TaxExemptionCertificatesSelectors";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<
    { certificateId: string },
    GetSingleTaxExemptionCertificateApiParameter,
    TaxExemptionCertificateModel
>;

export const DispatchSetCertificateId: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/TECNotification/SetCertificateId",
        certificateId: props.parameter.certificateId,
    });
};

export const DispatchLoadCertificateIfNeeded: HandlerType = props => {
    const taxExemptionCertificateState = getTECertificateState(props.getState(), props.parameter.certificateId);
    if (!taxExemptionCertificateState.value && !taxExemptionCertificateState.isLoading) {
        props.dispatch(loadTaxExemptionCertificatesByCertificateId(props.parameter));
    }
};

export const chain = [DispatchSetCertificateId, DispatchLoadCertificateIfNeeded];

const displayCertificate = createHandlerChainRunner(chain, "DisplayCertificate");
export default displayCertificate;
